export default __webpack_public_path__ + "static/media/angbao-bonus_dewali.d92fbc94.webp";